// src/components/CollapsibleSection.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Material UI Imports
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// Icons
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

// Import our FadeInSection component
import FadeInSection from '../user_interface/FadeInSection';

// Placeholder image
import PLACEHOLDER_IMAGE from 'assets/placeholder_image.png';

// --- THEME COLORS ---
const colors = {
    cardBackground: 'rgba(34, 34, 34, 0.9)',
    cardBorder: '#19abf0',
    textColor: '#ffffff',
    accentColor: '#19abf0',
    buttonBg: '#19abf0',
    buttonHover: '#0095db',
    iconColor: '#ffffff',
};

// Styled Icons
const StyledAddIcon = () => (
    <AddIcon sx={{ width: '2rem', height: '2rem', color: colors.iconColor }} />
);

const StyledRemoveIcon = () => (
    <RemoveIcon sx={{ width: '2rem', height: '2rem', color: colors.iconColor }} />
);










const CollapsibleSection = ({
    title,
    summary,
    summary2,
    fullText,


    children,
    imageSrc = PLACEHOLDER_IMAGE,
    imageAlt = 'Section Image',
    learnMoreLink,
    learnMoreText = 'Learn More',
    delay = 0,
    cardStyle = {},
    imagePosition = 'left',

    displayLink = false,
    displayImage = true,

    expanded
}) => {

    const [openStatus, setOpenStatus] = useState(expanded);
    console.log('expanded = ', expanded)
    // if (expanded == true) {
    //     setOpenStatus(true);
    // }
    // else {
    //     setOpenStatus(false);
    // }

    const navigate = useNavigate();

    const handleToggle = (event) => {
        if (event.target.closest('button')) {
            event.stopPropagation();
        }
        setOpenStatus(!openStatus);
    };

    const handleLearnMoreClick = () => {
        if (learnMoreLink) {
            navigate(learnMoreLink);
        }
    };





















    return (
        <div style={{
            width: '100%',
            margin: '0px 0',
            boxSizing: 'border-box',
            padding: '0px',
        }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',

                    // flexDirection: {
                    //     xs: 'column',
                    //     sm: imagePosition === 'left' ? 'row' : 'row-reverse',
                    // },

                    opacity: '0.8',

                    alignItems: 'flex-start', // <--- CHANGED: Align items to the start
                    justifyContent: 'center',
                    width: '100%',
                    maxWidth: '1000px',
                    margin: '0 auto',
                    // backgroundColor: colors.cardBackground,
                    borderRadius: '8px',
                    // boxShadow: `0px 2px 10px ${colors.cardBorder}20`,
                    // border: `1px solid ${colors.cardBorder}80`,
                    overflow: 'hidden',
                    transform: 'translateZ(0)',
                    WebkitTransform: 'translateZ(0)',
                    ...cardStyle,
                }}
            >

















                {/* --- Image Section --- */}
                {/* {displayImage && (
                    <Box sx={{
                        flexShrink: 0,
                        padding: '0rem',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start', // <--- CHANGED: Align image itself to start vertically

                        //  width: { xs: '100%', sm: 'auto' },
                        width: '100%',
                        marginBottom: { xs: '0rem', sm: '0' },
                        order: { xs: 0, sm: imagePosition === 'left' ? 0 : 1 },
                    }}>
                        <img
                            src={imageSrc}
                            alt={imageAlt}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '8rem',
                                width: 'auto',
                                height: 'auto',
                                padding: '1rem',
                                margin: '1rem',
                                // borderRadius: '4px',
                                //objectFit: 'contain',


                                // <--- CHANGED: Specific border-radius for corners ---
                                // borderRadius: '25px 0 25px 0', // Top-left: 15px, Top-right: 0, Bottom-right: 15px, Bottom-left: 0

                                borderRadius: '10% 10% 10% 10%', // Top-left: 15px, Top-right: 0, Bottom-right: 15px, Bottom-left: 0


                                objectFit: 'contain',

                                boxShadow: `0px 0px 10px 5px ${colors.cardBorder}90`,
                                border: `1px solid ${colors.cardBorder}80`,

                                // box-shadow: 0px 0px 10px 5px rgba(21, 140, 196, 0.7);

                            }}
                        />
                    </Box>
                )} */}















                {/* --- Card Section (for Title, Summary, and Collapsible Content) --- */}
                <Card
                    sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        border: 'none',
                        borderRadius: '0',

                        // width: { xs: '100%', sm: 'auto' },
                        width: ' 100%',

                        flexGrow: 1,
                        padding: '0',
                    }}
                >
                    {/* Card Header - always visible */}
                    {/* <CardHeader
                        onClick={handleToggle}
                        sx={{
                            padding: '1rem',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                        title={
                            <Typography
                                variant="h5"
                                sx={{
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '1.5rem',
                                    fontWeight: 'bold',
                                    color: colors.accentColor,
                                    textAlign: 'left',
                                    userSelect: 'none',
                                    flexGrow: 1,
                                }}
                            >
                                {title}
                            </Typography>
                        }

                        subheader={
                            <div
                                style={{
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '1.4rem',
                                    color: colors.textColor, // colors.textColor,
                                    textAlign: 'center',
                                    paddingTop: '1rem',
                                    paddingLeft: '2rem',
                                    // paddingRight: '0rem',
                                    // marginRight: '0rem',
                                    fontWeight: 'bold',
                                }}
                            >
                                {summary}
                            </div>
                        }

                        action={
                            <IconButton
                                onClick={handleToggle}
                                aria-label="expand"
                                size="large"
                                sx={{
                                    color: colors.iconColor,
                                    flexShrink: 0,
                                    marginLeft: '1rem',
                                }}
                            >



                                {openStatus ?
                                    <div style={{ width: '5rem', borderRadius: '1rem', padding: '0.5rem', backgroundColor: 'rgba(25, 171, 240,0.20)' }}>
                                        <StyledRemoveIcon />
                                        <div><p style={{ fontSize: '0.7rem', fontFamily: 'orbitron_medium', margin: '0px', padding: '0px' }}>LESS</p>
                                        </div>
                                    </div>
                                    :
                                    <div style={{ width: '5rem', borderRadius: '1rem', padding: '0.5rem', backgroundColor: 'rgba(0, 105, 147,0.30)' }}>
                                        <StyledAddIcon />
                                        <div><p style={{ fontSize: '0.7rem', fontFamily: 'orbitron_medium', margin: '0px', padding: '0px' }}>MORE...</p>
                                        </div>
                                    </div>
                                }



                            </IconButton>
                        }
                    /> */}





                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            //padding: '1rem'
                            //padding: '2%',
                            //margin: '1rem',
                            // marginLeft:'5rem'


                            width: '100%',
                            //backgroundColor:'gray',
                        }}>


                            <Typography
                                variant="h5"
                                sx={{
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '1.5rem',
                                    fontWeight: 'bold',
                                    color: colors.accentColor,
                                    textAlign: 'left',
                                    userSelect: 'none',
                                    flexGrow: 1,
                                    //backgroundColor: 'rgb(71, 47, 47)'
                                }}
                            >
                                {title ?
                                    <div style={{ margin: '2rem' }}>
                                        {title}
                                    </div>
                                    :
                                    <div style={{ margin: '0rem', padding: '0rem' }}></div>
                                }


                            </Typography>
                            <div
                                style={{
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '1.4rem',
                                    color: colors.textColor, // colors.textColor,
                                    textAlign: 'left',
                                    padding: '0rem',
                                    //paddingTop: '1rem',
                                    //paddingLeft: '2rem',
                                    // paddingRight: '0rem',
                                    // marginRight: '0rem',
                                    //fontWeight: 'bold',
                                    //backgroundColor: 'rgb(85, 65, 65)'

                                    display: 'flex',


                                    justifyContent: 'center',
                                }}
                            >
                                <div style={{ maxWidth: '800px', fontSize: '1.3rem' }}>


                                    {summary ?
                                        <div style={{ margin: '1rem' }}>
                                            {summary}
                                        </div>
                                        :
                                        <div style={{ margin: '0rem', padding: '0rem' }}></div>
                                    }

                                    {summary2 ?
                                        <div style={{ margin: '1rem' }}>
                                            {summary2}
                                        </div>
                                        :
                                        <div style={{ margin: '0rem', padding: '0rem' }}></div>
                                    }

                                </div>

                            </div>


                        </div>



                        <IconButton
                            onClick={handleToggle}
                            aria-label="expand"
                            size="large"
                            sx={{
                                color: colors.iconColor,
                                flexShrink: 0,
                                margin: '0rem',
                                padding: '2%',
                            }}
                        >


                            {expanded ?
                                <div>

                                </div> :
                                <div>
                                    {openStatus ?
                                        <div style={{ width: '5rem', borderRadius: '1rem', padding: '0.5rem', backgroundColor: 'rgba(25, 171, 240,0.20)' }}>
                                            <StyledRemoveIcon />
                                            <div><p style={{ fontSize: '0.7rem', fontFamily: 'orbitron_medium', margin: '0px', padding: '0px' }}>LESS</p>
                                            </div>
                                        </div>
                                        :
                                        <div style={{ width: '5rem', borderRadius: '1rem', padding: '0.5rem', backgroundColor: 'rgba(0, 105, 147,0.30)' }}>
                                            <StyledAddIcon />
                                            <div><p style={{ fontSize: '0.7rem', fontFamily: 'orbitron_medium', margin: '0px', padding: '0px' }}>MORE...</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }






                        </IconButton>

                    </div>
























                    {/* Collapsible Content */}
                    <Collapse
                        in={openStatus}
                        timeout="auto"
                        unmountOnExit

                        sx={{
                            padding: '0rem',
                            margin: '0rem',
                        }}

                    >
                        <CardContent
                            sx={{
                                padding: '0rem',
                                // marginLeft: '2rem',
                                padding: '1rem',
                                //backgroundColor: 'gray',
                            }}
                        >
                            <div
                                style={{
                                    //marginBottom: learnMoreLink ? '1rem' : '0',
                                    color: '#ffffff',
                                    fontSize: '1.3rem',
                                    textAlign: 'left',
                                    padding: '0rem',
                                    width: '100%',

                                    display: 'flex',
                                    justifyContent: 'center',

                                    //padding:'1rem',


                                }}>
                                <div style={{ maxWidth: '800px', }}>
                                    {children}
                                </div>

                            </div>



                            {learnMoreLink && displayLink && (
                                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                                    <Button
                                        onClick={handleLearnMoreClick}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: colors.accentColorDarker,
                                            color: colors.textColor,
                                            padding: '10px 20px',
                                            borderRadius: '5px',
                                            fontSize: '1rem',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {learnMoreText}
                                    </Button>
                                </Box>
                            )}


                        </CardContent>
                        {/* <p>test</p> */}
                    </Collapse>
                </Card>
            </Box>
        </div>
    );
};

export default CollapsibleSection;